export default __webpack_public_path__ + "static/media/1_Cs.cb413d19.svg";